/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOAD_APP = 'MFE/MBP/CHECKOUT/LOAD_APP';
export const SET_BRAND_CONFIG = 'MFE/MBP/CHECKOUT/SET_BRAND_CONFIG';
export const SET_FEATURE_FLAG = 'MFE/MBP/CHECKOUT/SET_FEATURE_FLAG';
export const SET_SESSION_FLAG = 'MFE/MBP/CHECKOUT/SET_SESSION_FLAG';
export const LOAD_SESSION_FLAG = 'MFE/MBP/CHECKOUT/LOAD_SESSION_FLAG';

export default {};
